import Cookies from 'js-cookie';

const SIERRA_CHAT_OPEN_KEY = 'sierra_chat_open';
const COOKIE_DOMAIN = '.stamps.com';
const COOKIE_PATH = '/';

/**
 * Mark the Sierra chat as open by setting a cookie.
 * This cookie is shared across all *.stamps.com subdomains.
 */
export const markChatOpen = () => {
	Cookies.set(SIERRA_CHAT_OPEN_KEY, 'true', {
		domain: COOKIE_DOMAIN,
		path: COOKIE_PATH,
		expires: 1, // 1 day expiration
		secure: true,
		sameSite: 'Lax',
	});
};

/**
 * Mark the Sierra chat as closed by removing the cookie.
 */
export const markChatClosed = () => {
	Cookies.remove(SIERRA_CHAT_OPEN_KEY, {
		domain: COOKIE_DOMAIN,
		path: COOKIE_PATH,
	});
};

/**
 * Check if the Sierra chat was open before the current page load.
 * @returns {boolean}
 */
export const wasChatOpenBeforeRefresh = () => {
	return Cookies.get(SIERRA_CHAT_OPEN_KEY) === 'true';
};

/**
 * Get the current chat open state.
 * @returns {boolean}
 */
export const isChatOpen = () => {
	return Cookies.get(SIERRA_CHAT_OPEN_KEY) === 'true';
};
